import type { RoadmapMigrationsRequiredDetails } from "../../api/roadmapClient";

type AtlasMigrationsRequiredCalloutProps = {
  details: RoadmapMigrationsRequiredDetails;
  title?: string;
};

export function AtlasMigrationsRequiredCallout({
  details,
  title = "Migrations Prisma requises",
}: AtlasMigrationsRequiredCalloutProps): JSX.Element {
  const missingTables = details.missingTables ?? [];
  const suggestedFix = details.suggestedFix ?? [];

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-amber-900">
      <div className="text-sm font-semibold">{title}</div>
      <p className="mt-1 text-xs text-amber-900/90">
        Les tables Atlas ne sont pas encore disponibles sur cette base. Appliquez les migrations Prisma avant de
        poursuivre.
      </p>
      {missingTables.length ? (
        <div className="mt-3 text-xs">
          <div className="font-semibold uppercase tracking-wide text-amber-800/90">Tables manquantes</div>
          <ul className="mt-1 list-disc space-y-1 pl-5">
            {missingTables.map((table) => (
              <li key={table}>{table}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {suggestedFix.length ? (
        <div className="mt-3 text-xs">
          <div className="font-semibold uppercase tracking-wide text-amber-800/90">Commandes suggérées</div>
          <div className="mt-1 space-y-1">
            {suggestedFix.map((command) => (
              <div key={command} className="rounded bg-amber-100/60 px-2 py-1 font-mono text-[11px]">
                {command}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
